import { type FC } from 'react';
import { ChangePercentage } from '@/components/UI/Table/Reusable/APITable/APITable.model';

interface MetricChangeFromProps {
  value: ChangePercentage;
  onChange: (value: ChangePercentage) => void;
}

/**
 * Component for selecting how percentage metric changes are calculated.
 */
const MetricChangeFrom: FC<MetricChangeFromProps> = ({ value, onChange }) => {
  return (
    <div className="pa3 bb b--moon-gray">
      <PercentageChange value={value} onChange={onChange} />
    </div>
  );
};

interface PercentageChangeProps {
  value: ChangePercentage;
  onChange: (value: ChangePercentage) => void;
}

export const PercentageChange: FC<PercentageChangeProps> = ({ value, onChange }) => {
  const options: Record<ChangePercentage, string> = {
    [ChangePercentage.FirstTaken]: 'First taken',
    [ChangePercentage.LastTaken]: 'Last taken',
    [ChangePercentage.TrackingDate]: 'Tracking date',
    [ChangePercentage.DiseaseInductionDate]: 'Disease induction date',
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    onChange(event.target.value as ChangePercentage);
  };

  return (
    <div className="flex items-center">
      <div className="f6 near-black lh-title mr3">% Metric change from</div>
      <select aria-label="% Metric change from" value={value} onChange={handleChange} className="mb0">
        {(Object.keys(options) as Array<ChangePercentage>).map((key) => (
          <option key={key} value={key}>
            {options[key]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MetricChangeFrom;
